<template>
    <v-container grid-list-md pa-0 relative>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-card class="primary--border student_list" outlined>
                    <v-card-title class="title">
                        Bulk Device Sync
                    </v-card-title>
                    <v-scroll-y-transition>
                        <v-card outlined>
                            <v-card-title class="pb-0 mb-0">
                                <v-flex xs2>
                                    <v-grade-field :inside="true" v-model="grade_id"></v-grade-field>
                                   
                                </v-flex>
                                <v-flex xs2>
                                    <v-section-field  v-model="section_id" :gradeId="grade_id"></v-section-field>
                                </v-flex>
                                <v-flex xs2>
                                    <v-select
                                        :items="syncStatus"
                                        required
                                        class="pa-0"
                                        label="Sync Status"
                                        outlined
                                        dense
                                        :disabled="!grade_id" 
                                        v-model="sync_status"
                                      
                                    />
                                </v-flex>
                                <v-flex xs1>
                                    <search-button :permission="true" :disabled="!grade_id" @action="get()">
                                        Search
                                    </search-button>
                                </v-flex>
                            </v-card-title>
                        </v-card>
                    </v-scroll-y-transition>
                    <v-data-table
                        :headers="headers"
                        hide-default-footer
                        :items="buklkRefDatas"
                        :server-items-length="buklkRefDatas.length"
                        :loading="formLoading"

                    >
                    <!-- footer-props.items-per-page-options="rowsPerPageItems" -->
                        <template v-slot:item="{ index, item }">
                            <tr>
                                <td align="left">{{ ++index }}</td>
                                <td align="left">{{ item.name}}</td>
                                <td align="left">{{ item.enroll_code}}</td>
                                <td align="left">{{ item.roll}}</td>
                                <td align="left">
                                    <span v-if="item.sync_status">
                                        <v-icon color="green">
                                            check_circle
                                        </v-icon>
                                    </span>
                                    <span v-else>
                                        
                                        <v-icon color="red">
                                            cancel
                                        </v-icon>
                                    </span>
                                </td>
                                <td align="left">{{ getDeviceName(item.device_id)}}</td>
                                <td align="right">
                                    <input
                                        @change="enableSubmit = true"
                                        v-model="item.rfid_number"
                                        type="text"
                                        class="inputTime"
                                        :disabled="!item.can_insert"
                                        style="width: 100%; padding: 2px 4px; border: 1px solid #ccc; border-radius: 4px;"
                                    />
                                </td>
                            
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-btn
                            @click="checkForDuplicatRefId()"
                            block
                            v-if="buklkRefDatas.length > 0"
                            large
                            color="success"
                            :disabled="!enableSubmit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="deviceModal" persistent max-width="400px">
            <v-card>
            <v-card-title class="primary white--text">
                <span class="title">Add/Update</span>
            </v-card-title>
            <v-card-text class="pb-1 pt-4">
                <v-select
                    :items="devices"
                    required
                    class="pa-0"
                    label="Device*"
                    outlined
                    dense
                    name="devoce"
                    v-model="device_id"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="warning"
                text
                @click="(deviceModal = false)"
                >Close</v-btn
                >
                <v-btn
                    :disabled="!device_id"
                    :loading="loading"
                    color="success"
                    text
                    @click="submitBulkRefId()"
                    >Save
                    </v-btn
                >
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import Mixins from "@/library/Mixins";
import { mapState } from "vuex";

import CommonFunction from "@/library/CommonFunction";
import SmartAttendance from "../../../../components/SmartAttendance.vue";
import SearchButton from "../../../../components/SearchButton.vue";

const NepaliDate = require("nepali-date-js");
const nd = new NepaliDate();
export default {
  components: {
    SmartAttendance,
  },
  mixins: [Mixins,CommonFunction],
  data: () => ({
        grades: [],
        sections: [],
        grade_id: '',
        section_id: '',
        buklkRefDatas: [],
        devices: [],
        loading: false,
        deviceModal: false,
        device_id: '',
        enableSubmit: false,
        formLoading: false,
        sync_status: 'all',
        headers: [
            { text: "#", align: "left", value: "sno", width: 5, sortable: false },
            { text: "Name", align: "left", value: "name", width: 50 },
            { text: "Enroll Code", align: "left", value: "enroll_code", width: 50 },
            { text: "Roll Number", align: "left", value: "roll", width: 50 },
            { text: "Sync Status", align: "left", value: "sync_status", width: 50 },
            { text: "Device", align: "left", value: "device", width: 50 },
            { text: "Rfid", align: "right", value: "rfid_number", width: 50 },

        
        ],
        syncStatus: [
			{
				text: "All",
				value: "all",
			},
			{
				text: "Sync",
				value: "1",
			},
			{
				text: "Not Sync",
				value: "0",
			},
		],
    }), 
  
    mounted() {
        this.getDevices()
    },
    computed: {
        ...mapState(["batch"]),

    },
    watch: {
        grade_id() {
            this.buklkRefDatas = []
        },
        section_id() {
            this.buklkRefDatas = []
        }
    },
    methods: {
        get(){
            this.formLoading = true
            this.$rest.get('/api/bulk-device-sync?grade_id='+this.grade_id+"&section_id="+this.section_id+"&sync_status="+this.sync_status)
            .then((res) => {
                this.buklkRefDatas = res.data.data
            }).finally(() => {
                this.formLoading = false
            })
        },
    
        
        getDevices() {
            this.$rest.get("/api/attendance-devices").then(({data}) => {
                this.devices = data.data.map(item => ({
                    text: item.name,
                    value: item.device_index
                }));
            })
        },
        checkForDuplicatRefId() {
            const validEntries = this.buklkRefDatas.filter(
                (item) => item.can_insert === true && item.rfid_number
            );

            const rfidMap = {};
            const duplicateRfids = [];

            validEntries.forEach((item) => {
                const rfid = item.rfid_number.trim();
                if (rfid) {
                    if (rfidMap[rfid]) {
                        if (!duplicateRfids.includes(rfid)) {
                            duplicateRfids.push(rfid);
                        }
                    } else {
                        rfidMap[rfid] = true;
                    }
                }
            });
            if (duplicateRfids.length > 0) {
                this.loading = false;

                this.$events.fire("notification", {
                    message: `Duplicate RFID numbers: ${duplicateRfids.join(', ')}`,
                    status: "error",
                });

                return; 
            }
            this.deviceModal = true;


        },
        submitBulkRefId(){
            this.loading = true
            const validEntries = this.buklkRefDatas.filter(
                (item) => item.can_insert === true && item.rfid_number
            );
            const deviceName = this.devices.find(device => device.value === this.device_id)?.text ?? null;
            if(!this.device_id || !deviceName) {
                return  this.$events.fire("notification", {
                    message: 'Device is required',
                    status: "error",
                });
            }
            this.$rest.post("/api/bulk-device-sync", {
                device_id: this.device_id,
                studentRecords: validEntries,
                device_name: deviceName
            }).then((res) => {
                this.$events.fire("notification", {
                    message: res.data.message,
                    status: "success",
                });
                this.deviceModal = false
                this.resetValues();
                this.get();
            }).catch((err) => {
                this.$events.fire("notification", {
                    message: err.response.data.message,
                    status: "error",
                });
                this.deviceModal = false

            })
            .finally(() => {
                this.loading = false;
            })

        },
        resetValues(){
            this.device_id = '';

        },
        getDeviceName(deviceId) {
            const device = this.devices.find((item) => item.value === deviceId);
            return device ? device.text : '';
        }
    
    },
};
</script>
<style lang="scss" scoped>
.v-chip,
.v-chip .v-chip__content {
  border-radius: 3px;
  color: white;
  font-weight: bold;
}
</style>
